module.exports = __webpack_public_path__ + "files/LifePassEULA.5840476e.pdf";